import React, { useRef, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
//import DeleteIcon from '@mui/icons-material/Delete';
//import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchDataActive, fetchData, postData, updateData, deleteData, activateData } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import {
    Search as SearchIcon,
    Add as AddIcon,
    Edit as EditIcon,
    Delete as DeleteIcon
} from '@mui/icons-material';

//import '../../styles.css';
function CIndex() {
    const inputRef = useRef(null);
    const [data, setData] = useState([]);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const history = useHistory(); // Access the navigation history
    const [errorMessage, setErrorMessage] = useState("");
    const { isAuthenticated, clubId, userId, permissions, logout, token } = useAuth();
    const [successMessage, setSuccessMessage] = useState("");
    const [isButtonVisible, setIsButtonVisible] = useState(false); // initially set to false

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }
        // Token is not expired, fetch data
        fetchtableData();
        //  inputRef.current.focus();
    }, [isAuthenticated, clubId, token, logout]);
    const closeConfirmDialog = () => {
        // setDeleteMember(null);
        setConfirmDialogOpen(false);
    };
    useEffect(() => {
        if (searchTerm.trim() == '') {
            setFilteredData(data);
        } else {
            const filtered = data.filter(manu => manu.name.toLowerCase().includes(searchTerm.toLowerCase()));
            setFilteredData(filtered);
        }
    }, [data, searchTerm]);

    const fetchtableData = async () => {
        fetchData('ClubApi', `/${clubId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                    setFilteredData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Club Details:', error);
                // Handle error, e.g., redirect to login if token is expired
                if (error.response && error.response.status === 401) {
                    logout();
                    // Redirect to login with the current location as a parameter
                    history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
                }
            });
    };



    return (
        <div className="w-full max-w-sm container mt-2 mx-auto">
            <div className='w-full mb-2 flex'>

                <h6 className='productHead flex-grow linkcolor'
                    style={{ color: '#14528B', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
                    CLUB</h6>


                <div className="button-container-1">
                    {isButtonVisible && (
                        <Button
                            component={Link}
                            // onClick={toggleModalCreate}
                            className="linkcolor"
                            style={{ marginLeft: '8px', fontWeight: 'bolder', backgroundColor: '#0e728c', color: 'white' }}
                        >
                            <AddIcon /> CREATE
                        </Button>
                    )}
                </div>


            </div>

            {/* <div className='w-full mb-2 flex'>
                <input
                    ref={inputRef}//mouse pointer focus to textfield
                    type="text"
                    placeholder="Search by Person name"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="search-input shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                />
            </div> */}
            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table>
                        {/* <TableHead sx={{ backgroundColor: '#0c8bce', fontFamily: 'sans-serif' }}> */}
                        <TableHead sx={{ backgroundColor: '#BAD8B6', fontFamily: 'sans-serif' }}>
                            <TableRow>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '5px', color: 'black', fontWeight: 'bold' }}>Company</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '5px', color: 'black', fontWeight: 'bold' }}>Code</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '5px', color: 'black', fontWeight: 'bold' }}>Address</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '5px', color: 'black', fontWeight: 'bold' }}>GST No</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '5px', color: 'black', fontWeight: 'bold' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>


                        <TableBody >
                            {filteredData.map((club, index) => (
                                <TableRow
                                    key={index}
                                    sx={{
                                        backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8fcff', // Alternate row background colors
                                    }}
                                >




                                    <TableCell sx={{ padding: '10px', padding: '5px' }}>{club.Name}</TableCell>
                                    <TableCell sx={{ padding: '10px', padding: '5px' }}>{club.ClubCode}</TableCell>
                                    <TableCell sx={{ padding: '10px', padding: '5px' }}>{club.AddressLine1}</TableCell>
                                    <TableCell sx={{ padding: '10px', padding: '5px' }}>{club.GSTNumber}</TableCell>
                                    <TableCell sx={{ padding: '10px', padding: '5px' }}>

                                        <Link to={`/ClubEdit/${club.ID}`}>
                                            <IconButton>
                                                <EditIcon style={{ fontsize: '20px', color: 'blue' }} />
                                            </IconButton>
                                        </Link>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete this record?
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <button onClick={closeConfirmDialog} className="cancelbutton">
                                    Cancel
                                </button>
                            </DialogActions>
                        </Dialog>
                    </Table>
                </TableContainer>
            </div>
        </div>
    );
}

export default CIndex;




